import React from 'react';

interface DownloadIconProps {
  color?: string;
}

const DownloadIcon: React.FC<DownloadIconProps> = ({ color }) => {
  return (
    <div>
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 12.5L8.29289 13.2071L9 13.9142L9.70711 13.2071L9 12.5ZM10 3.5C10 2.94772 9.55229 2.5 9 2.5C8.44772 2.5 8 2.94771 8 3.5L10 3.5ZM3.79289 8.70711L8.29289 13.2071L9.70711 11.7929L5.20711 7.29289L3.79289 8.70711ZM9.70711 13.2071L14.2071 8.70711L12.7929 7.29289L8.29289 11.7929L9.70711 13.2071ZM10 12.5L10 3.5L8 3.5L8 12.5L10 12.5Z"
          fill={color || 'currentColor'}
        />
        <path d="M3.75 16.25L14.25 16.25" stroke={color || 'currentColor'} strokeWidth="2" />
      </svg>
    </div>
  );
};

export { DownloadIcon };
